import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { isBlackberryMode } from '../utils/general/general';
import DomTemplate from '../mainpage/domTemplate';
import { enterKeyPressed } from '../utils/general/enterKey';
import shortid from 'shortid';
import $ from "jquery";

interface IFootnoteTemplateProps {
    source: any;
}

class FootnoteTemplate extends PureComponent<IFootnoteTemplateProps, any> {

    constructor(props: IFootnoteTemplateProps) {
        super(props);
        this.state = {
            modalStatus: false
        };
    }

    public clickFootNote(e: any, source: any) {
        const target: any = $(e.target);
        target.addClass('triggered_popup_flag');
        e.stopPropagation();
        if (!document.getElementById('footNoteModal') && !this.state.modalStatus && !isBlackberryMode()) {
            this.setState({
                modalStatus: true
            });
            const newdiv = document.createElement('div');           // create footnote modal container
            const att = document.createAttribute("id");
            att.value = "footNoteModal";

            const getTop = target.offset().top - 100;

            let getLeft = target.offset().left;
            const tempX = window.innerWidth - getLeft - 350;
            if ( tempX < 0 ) {
                getLeft = getLeft + tempX;
            }

            newdiv.style.left = getLeft + 'px'; // pageX pageY clientX clientY
            newdiv.style.top = getTop + 'px';
            newdiv.tabIndex = 0;
            newdiv.setAttributeNode(att);

            const backDrop: any = document.createElement('div');    // create the background mask for the modal
            const backDropAtt = document.createAttribute("id");
            backDropAtt.value = "common-modal-backdrop";
            backDrop.setAttributeNode(backDropAtt);

            document.body.appendChild(newdiv);
            document.body.appendChild(backDrop);
            backDrop.onclick = () => {                              // when click anywhere beside the modal, show hide the modal and the mask
                this.removeModal(target);
            };

            const footNoteContainer = [];
            const container =
                (
                    <div className="footnotecontainer" key={shortid.generate()}>
                        <DomTemplate sourceM={source} dataStringM={'paragraph'} classNameM={''} />
                    </div>
                );
            footNoteContainer.push(container);
            ReactDOM.render(footNoteContainer, document.getElementById('footNoteModal'));
            newdiv.focus();
            newdiv.onkeydown = (event: any) => {
                const code = event.keyCode || event.which;
                if (code === 27) {
                    this.removeModal(target);
                }
            };
        }
    }

    public removeModal(target: any) {
        $('#common-modal-backdrop, #footNoteModal').remove();
        this.setState({
            modalStatus: false
        });
        target.focus().removeClass('triggered_popup_flag');
    }

    public render() {
        const { source } = this.props;
        let classValue = "";
        let classString = "";
        if (source.format && source.format['class']) {
            classValue = source.format['class'];
        }
        classString = 'x-rsch-run ' + 'x-footnote ' + (classValue || '' );
        const footnoteTemplate =
            (
                <span className={classString}
                      role="button"
                      aria-label={source.text}
                      tabIndex={0} key={shortid.generate()}
                      onClick={(e) => this.clickFootNote(e, source.footnote)}
                      onKeyPress={(e) => enterKeyPressed(e, this.clickFootNote.bind(this, e, source.footnote))}
                >
                    {source.text}
                </span>
            );

        return (
            <span className="footnote-template-part">{footnoteTemplate}</span>
        );
    }
}

export default FootnoteTemplate;
